
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt.json") })
        }
      }, "path---projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt!./.cache/json/projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt!./.cache/json/projects-c-1-a-ks-yoe-ju-eyq-dwfe-h-0-zf-dt.json
// module chunks = 15178676390636814000